export function MapVAlign(oldAlign) {
  var vAlign = oldAlign;
  switch (oldAlign) {
    case "middle":
      vAlign = "m";
      break;
    case "top":
      vAlign = "t";
      break;
    case "bottom":
      vAlign = "b";
      break;
  }

  return vAlign;
}
